import DOMPurify from "dompurify";
import { createAsyncThunk } from "@reduxjs/toolkit";
import AuthService from "../../services/AuthServices";
import { errorsKey, getLeaderErrorsKey, setCookie } from "../../utils";
import { ErrorIcon } from "../../assets/icons/ErrorIcon";
import { message } from "antd";
import { ISignupWithLeaderIdArgs } from "../../types/types";
import { Errors, SetSignupLeaderIdStatus } from "../slices/userSlice";

const messageError = (content: any) =>
  message.error({
    className: "messageError",
    icon: <ErrorIcon />,
    content,
  });

export const signupLeaderId = createAsyncThunk<void, ISignupWithLeaderIdArgs>(
  "userSlice/signupWithLeaderId",
  async (args, { dispatch }) => {
    const { data } = await AuthService.$signup_with_leader_id(args);

    if (data.status) {
      setCookie('_utid', data.values[0], 90);
      setCookie('_s3_utid', data.values[1], 90);

      dispatch(SetSignupLeaderIdStatus(true));
    } else {
      const errorKey = data.errors[0].key;
      const errors = errorKey === 112 ? getLeaderErrorsKey(errorKey) : errorsKey(errorKey);
      messageError(errorsKey(errorKey));
      dispatch(Errors(errors));
      dispatch(SetSignupLeaderIdStatus(false));
    }
  }
);

export const loginWithLeaderId = createAsyncThunk(
  "userSlice/loginWithLeaderId",
  async (_) => {
    const { data } = await AuthService.$auth_with_leader_id();

    if (data.status) {
      const redirectURL = DOMPurify.sanitize(data.values[0]);
      window.location.href = redirectURL;
    } else {
      messageError(errorsKey(data.errors[0].key));
    }
  }
);

